import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './Navigation.css';

export default function Navigation({ user, onLogout }) {
  const navigate = useNavigate();
  const [adminOpen, setAdminOpen] = useState(false);
  const [opsOpen, setOpsOpen] = useState(false);
  const navRef = useRef(null);

  const handleLogout = () => {
    onLogout();
    navigate('/login');
  };

  const isAdmin = user?.role === 'admin';
  const isOperations = user?.role === 'operations';

  // Close dropdowns when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setAdminOpen(false);
        setOpsOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLinkClick = () => {
    setAdminOpen(false);
    setOpsOpen(false);
  };

  return (
    <nav className="navigation" ref={navRef}>
      <div className="nav-brand">
        <Link to="/" onClick={handleLinkClick}>Shesha Logistics</Link>
      </div>

      <div className="nav-menu">
        <Link to="/inventory" className="nav-link" onClick={handleLinkClick}>Stock</Link>

        {/* Admin Menu */}
        {isAdmin && (
          <div className="nav-dropdown">
            <button 
              className="nav-link"
              onClick={() => setAdminOpen(!adminOpen)}
            >
              Admin ▼
            </button>
            {adminOpen && (
              <div className="dropdown-content">
                <Link to="/suppliers" onClick={handleLinkClick}>Manage Suppliers</Link>
              </div>
            )}
          </div>
        )}

        {/* Operations Menu */}
        {(isAdmin || isOperations) && (
          <div className="nav-dropdown">
            <button 
              className="nav-link"
              onClick={() => setOpsOpen(!opsOpen)}
            >
              Operations ▼
            </button>
            {opsOpen && (
              <div className="dropdown-content">
                <Link to="/packing-list-upload" onClick={handleLinkClick}>Upload Packing List</Link>
                <Link to="/packing-lists" onClick={handleLinkClick}>View Packing Lists</Link>
                <Link to="/delivery-notes" onClick={handleLinkClick}>Delivery Notes</Link>
              </div>
            )}
          </div>
        )}

        <div className="nav-user">
          <span className="user-name">{user?.full_name || user?.username}</span>
          <button onClick={handleLogout} className="logout-btn">Logout</button>
        </div>
      </div>
    </nav>
  );
}
